<template>
    <div class="word-press-opt-in-goal">
        <GoalModal
            :is-open="isOpen"
            :title="$t('funnel.edit.sideBar.goal.wordPress.title')"
            :summary-text="$t('funnel.edit.sideBar.goal.wordPress.summary')"
            :goal-tip-text="$t('funnel.edit.sideBar.goal.wordPress.tip.overview')"
            :goal-tip-link="toolTipLink"
            :cell="cell"
            :cell-type="cellType"
            @update-config="saveCellValue"
            @close-modal="closeModal"
        >
            <template #goalParameters>
                <section class="opt-in-form">
                    <DsMultiselect
                        v-model="selectedOptInForm"
                        bind-value-only
                        class="selected-purchase-type"
                        required
                        :readonly="loading"
                        :loading="loading"
                        :placeholder="placeholderResultLabel"
                        :options="optInFormOptions"
                        :force-invalid="emptyOptInForm"
                    >
                        <template #help>
                            <span v-if="emptyOptInForm" data-qa="invalid-opt-form">
                                {{ $t('global.field.required') }}
                            </span>
                        </template>
                    </DsMultiselect>
                </section>
            </template>
        </GoalModal>
    </div>
</template>

<script>
import { loadWordPressList } from './WordPressOptIn.api';
import { GOAL_WORDPRESS_OPTIN } from '../../../utils/editor.constants';
import GoalModal from '../goalModal/GoalModal.vue';

export default {
    components: {
        GoalModal,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },

        appInfo: {
            type: Object,
            required: true,
        },

        cell: {
            type: Object,
            default: () => ({
                value: {
                    optInForm: 0,
                },
            }),
        },
    },
    emits: ['close-modal', 'update-cell-value'],
    data() {
        return {
            cellType: GOAL_WORDPRESS_OPTIN,
            selectedOptInForm: 0,
            optInFormOptions: [],
            loading: false,
            emptyOptInForm: false,
        };
    },
    computed: {
        placeholderResultLabel() {
            return this.$t('funnel.edit.sideBar.goal.wordPress.placeholder');
        },
        isSpaApp() {
            return this.appInfo?.appEditionFlags?.spaApp;
        },
        toolTipLink() {
            return this.isSpaApp ? this.$t('funnel.edit.sideBar.goal.wordPress.tip.keap.link') : this.$t('funnel.edit.sideBar.goal.wordPress.tip.core.link');
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            try {
                this.loading = true;

                const listWPOptIn = await loadWordPressList();

                this.optInFormOptions = listWPOptIn.map((wp) => {
                    return {
                        value: Number(wp.id),
                        label: wp.optinName,
                        icon: 'form',
                    };
                });

                const optInForm = this.cell.value?.optInForm ? Number(this.cell.value.optInForm) : NaN;

                this.selectedOptInForm = Number.isNaN(optInForm) ? 0 : optInForm;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Could not load product purchased: ${error}`);
            } finally {
                this.loading = false;
            }
        },
        saveCellValue() {
            if (this.selectedOptInForm) {
                const cell = { ...this.cell };

                cell.value = cell.value || {};
                cell.value.optInForm = this.selectedOptInForm;

                this.$emit('update-cell-value', { cell });
            } else {
                this.emptyOptInForm = true;
            }
        },
        closeModal() {
            this.$emit('close-modal', GOAL_WORDPRESS_OPTIN);
        },
    },
};
</script>
